import React, { useState, useEffect } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button,Box, Container, Card, CardHeader, CardContent, List, ListItem, ListItemText, IconButton, InputAdornment} from '@material-ui/core';
import InputText from './views/components/payg/commonModules/interface/form-input-inline';

import { logUser, logUserPart1,resetPwd } from './jsx/actions/authAction'
import {  toast } from 'react-toastify';
import PopUp from "./views/components/payg/commonModules/interface/PopUp";
import { BuildRounded, LoginRouded, Person, Visibility, VisibilityOff } from "@material-ui/icons";
import { isEmpty , isArray} from "lodash-es";

const LoginForm = (props) => {
	var [email, setEmail] = useState("");
	var [password, setPassword] = useState("");
	var [openPopUp, setPopUp] = useState(false);
	var [accountList, setAccountList] = useState([]);
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => setShowPassword((show) => !show);
  	const handleSubmitPart1 = async(form) => {
    	console.log('[ERROR],LoginPage,info,  err',email, ' => ',password);

		// find if match
		// get all accounts linked to this email + password 
		if(email && password){
			const resp = await props.logUserPart1({username:email, password:password});
			// resp must contain list of linked account
			console.log("Liste => ",resp)
			// if (resp === "ok"){
			if (!isEmpty(resp)){
				if (isArray(resp)){
					setAccountList(resp)
					setPopUp(true)
					return
				}
				if (resp == "ook"){
					props.onSuperLogin("ok")
					return
				}
			}

			let msg = "Un Problème est survenu  : "+resp;
			console.log('[ERROR],LoginPage,handleSubmit,  err',resp);
			if (resp=== "user and password don't match"){
				msg = "Un Problème est survenu  : Le mot de passe et l'email ne correspondent pas"
			}
			toast.error(msg)
			
			return;
		} else {
			toast.error("Le Formulaire contient des erreurs")
			return
		}
    }
  	const handleSubmitPart2 = async(userid,accountid) => {

		// use email only ???
		const resp = await props.logUser({ userid:userid,accountid:accountid });
		if (resp === "ok"){
			props.onLogin("ok")
			return
		}

		let msg = "Un Problème est survenu  : "+resp.data.error;
		console.log('[ERROR],LoginPage,handleSubmit,  err', resp.data.error);
		
		toast.error("Erreur ",msg)
		return;
    }
	const handleResetPwd = async() =>{
		try {
			const resp = await props.resetPwd({ fp_email_rst_pwd:email });
			
			// Check if response is successful
			if (resp && resp.data && resp.data.success) {
				toast.success(resp.data.message || "Email de réinitialisation envoyé avec succès");
				return;
			}
			
			// Handle error response
			if (resp && resp.data && resp.data.error) {
				let msg = "Un Problème est survenu : " + resp.data.error;
				console.log('[ERROR],LoginPage,handleResetPwd, err', resp.data.error);
				toast.error("Erreur", msg);
				return;
			}
			
			// Handle unexpected response
			toast.error("Erreur", "Réponse inattendue du serveur");
			
		} catch (err) {
			console.log("handleResetPwd, err", err);
			let errorMsg = "Erreur de connexion";
			if (err.response && err.response.data && err.response.data.error) {
				errorMsg = err.response.data.error;
			} else if (err.message) {
				errorMsg = err.message;
			}
			toast.error("Erreur", errorMsg);
		}
	}

    const setPreEmail = (e) =>{
		const { name, value } = e.target;
		console.log(email + " "+ value)
		setEmail(value)
    } 
    const setPrePwd = (e) =>{
		const { name, value } = e.target;
		console.log(password + " "+ value)
		setPassword(value)
    } 
   
    return(
      <Container maxWidth="sm" >
        {openPopUp &&
			<PopUp 
				appbar
				maxWidth="sm"
				title="Choisissez un compte"
				close={() => setPopUp(false)}
			>
				<List>
					{accountList.map( account => 
						<ListItem button onClick={() => handleSubmitPart2(account.userid,account.accountid) } >
							<ListItemText primary={account.accountname}/>
							<IconButton size="large">
								<Person />
							</IconButton>
						</ListItem>
					)}
					
				</List>
			</PopUp>
        }
        <Card className="login-form-box">
			<CardHeader title="Connexion" />
				<CardContent>
					<Box> 
						<InputText
							required
							name="email" 
							id="email" 
							value={email} 
							label="Email" 
							placeholder="Email ici" 
							// error={this.props.errors.email} 
							onChange={setPreEmail} 
						/>
						<InputText
							required
							// type="password"
							name="password" 
							id="password" 
							value={password} 
							label="Mot de Passe" 
							placeholder="Mot de Passe ici" 
							// error={this.props.errors.password} 
							onChange={setPrePwd} 
							type={showPassword ? 'text' : 'password'}
							endAction={
								<IconButton
									aria-label="toggle password visibility"
									onClick={handleClickShowPassword}
									// onMouseDown={handleMouseDownPassword}
									edge="end"
								>
									{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
								
							}
						/>
					</Box>  
					<Box p={2} style={{textAlign: "center"}} >
						<Button 
							color="secondary" 
							variant="contained" 
							size="large" 
							onClick={()=>handleSubmitPart1()} 
						>
							Se Connecter
						</Button>
					</Box>
					<Box p={1} style={{textAlign: "center"}} >
						<Button 
							color="primary" 
							variant="contained" 
							size="small" 
							onClick={()=>handleResetPwd()} 
						>
							Mot de passe oublié
						</Button>
					</Box>
            	</CardContent>
            </Card>
      </Container>
    )
  }




function mapStateToProps(state){
    return {
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
      	logUser,
		logUserPart1,
		resetPwd
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)